import { defineSchema } from '../../schema-meta.ts';
import { registerCategorySchema } from '../../registry.ts';

// 이벤트 전용 출석 — 일반 attendance-reward.ts 와 동일한 static/repeat 보상 구조.
// static 소진 시 핸들러가 이벤트 종료로 처리한다(repeat 사용 안 함).
// `isActive` 는 운영자 on/off 토글 — raw event_attendance.is_active 컬럼을 싱글톤
// 페이로드에 함께 실어 서버 claim 게이트가 별도 키 fetch 없이 바로 읽도록 한다.
export const EventAttendanceRewardSchema = defineSchema({
  name: 'serverEventAttendanceRewards',
  fields: [
    [
      'static',
      { kind: 'array', of: { kind: 'record', value: { kind: 'dict', dict: 'delivery' } } },
    ],
    [
      'repeat',
      { kind: 'array', of: { kind: 'record', value: { kind: 'dict', dict: 'delivery' } } },
    ],
    ['isActive', 'boolean'],
  ],
});

export interface RawEventAttendanceRewardRow {
  static: unknown;
  repeat: unknown;
  is_active?: boolean;
}

export function eventAttendanceRewardFromRaw(row: RawEventAttendanceRewardRow) {
  return { static: row.static, repeat: row.repeat, isActive: row.is_active !== false };
}

registerCategorySchema('serverEventAttendanceRewards', EventAttendanceRewardSchema);
